"use strict";
var FontPickerConfig = (function () {
    function FontPickerConfig(config) {
        if (config === void 0) { config = {}; }
        this.apiKey = null;
        this.assign(config);
    }
    FontPickerConfig.prototype.assign = function (config) {
        if (config === void 0) { config = {}; }
        for (var key in config) {
            this[key] = config[key];
        }
    };
    return FontPickerConfig;
}());
exports.FontPickerConfig = FontPickerConfig;
var Font = (function () {
    function Font(props) {
        this.family = props.family || 'monospace';
        this.styles = props.styles || ['regular'];
        this.style = props.style || 'regular';
        this.files = props.files || null;
        this.size = props.size || null;
    }
    Font.prototype.getStyles = function () {
        return {
            'font-size': this.size || '16px',
            'font-family': this.family || 'monospace',
            'font-style': this.style.includes('italic') ? 'italic' : 'normal',
            'font-weight': isNaN(Number(this.style.slice(0, 3))) ? 'normal' : this.style.slice(0, 3)
        };
    };
    return Font;
}());
exports.Font = Font;
var GoogleFonts = (function () {
    function GoogleFonts() {
    }
    return GoogleFonts;
}());
exports.GoogleFonts = GoogleFonts;



//////////////////
// WEBPACK FOOTER
// ./src/lib/interfaces.ts
// module id = 9
// module chunks = 0 1